'use strict';
const mmWidgets = require('../widgets/mm-widgets');
require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');
require('./sub-team-member-widget');
require('./sub-team-addable-member-list-widget');

mmWidgets.fn.subteamConfigWidget = function (subteamModel) {
	if (!subteamModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		let subteam, currentMemberList;
		const element = this.sectionHandlerWidget(),
			memberListTemplate = element.find('[data-mm-role~="member-list-template"]').detach(),
			memberListContainer = element.find('[data-mm-role~="member-list-container"]'),
			showMemberList = memberList => {
				currentMemberList = memberList;
				memberListContainer.empty();
				memberList.forEach(member => {
					const memberWidget = memberListTemplate.clone();
					memberWidget.appendTo(memberListContainer);
					memberWidget.subteamMemberWidget(subteamModel, subteam, member, element);
				});
				element.showSection('member-list');
			};
		element.find('[data-mm-role~="addable-member-list-container"]').subteamAddableMemberListWidget(subteamModel, element);
		subteamModel.addEventListener('subteamUpdated', updatedSubteam => subteam = updatedSubteam);
		subteamModel.addEventListener('requestConfigureSubteam', toConfigure => {
			subteam = toConfigure;
			element.find('[data-mm-role~=sub-team-name]').text(subteam.description);
			element.showProgressMessage('Loading group members, please wait...');
			element.removeClass('hidden');
			return subteamModel.loadMemberList(subteam)
			.then(showMemberList)
			.then(() => element.trigger('testhook:load-complete'));
		});
		element.find('[data-mm-role~="add-sub-team-member"]').click(() => {
			element.showProgressMessage('Loading addable members, please wait...');
			subteamModel.listAddableMembers(subteam, currentMemberList);
		});
		subteamModel.addEventListener('showAddableEmails', (updatedSubteam, addableEmails) => {
			subteam = updatedSubteam;
			if (addableEmails && addableEmails.length) {
				element.showSection('addable-member-list');
			} else {
				element.showSection('no-addable-members');
			}

		});
		element.find('[data-mm-role~="reload-subteam-member-list"]').click(function () {
			subteamModel.requestConfigureSubteam(subteam);
		});
		element.on('memberList', evt => {
			showMemberList(evt.memberList);
			element.trigger('testhook:member-list-complete');
		});
	});
};
